import { render, staticRenderFns } from "./MrfEventsEdit.vue?vue&type=template&id=4e961336"
import script from "./MrfEventsEdit.vue?vue&type=script&lang=js"
export * from "./MrfEventsEdit.vue?vue&type=script&lang=js"
import style0 from "./MrfEventsEdit.vue?vue&type=style&index=0&id=4e961336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports